import { DOWNLOAD_FOLDER_LOGO } from '../utils/constants/images';

const DownloadProgressDropdown = ({ downloadProgress }) => {
    const progress = Math.floor((downloadProgress.fileCount / downloadProgress.totalFiles) * 100) || 0;

    return (
        <div className="  w-full">
            <h3 className=" pb-4">Downloads</h3>
            {progress ? (
                <div className="flex w-full items-center">
                    <div className="">
                        <img src={DOWNLOAD_FOLDER_LOGO} height="72" alt="" />
                    </div>
                    <div className=" w-full">
                        <p className="mx-2">Request {downloadProgress.requestName}</p>
                        <p className="mx-2 pt-1 pb-2 text-gray-500 text-xs">
                            {downloadProgress.fileCount}/{downloadProgress.totalFiles}
                        </p>
                        <div className=" mx-2 h-1 bg-blue-100 rounded">
                            <div className=" p-0 m-0 h-1 bg-blue-400 rounded" style={{ width: `${progress}%` }}></div>
                        </div>
                    </div>
                </div>
            ) : (
                <p className="text-gray-500 text-xs"> No Downloads </p>
            )}
        </div>
    );
};

export default DownloadProgressDropdown;
